
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { CargarFotoARLComponent } from './cargar-foto-arl.component';
import { CargarFotoARLRouting } from './cargar-foto-arl-routing.module';

  
  @NgModule({
    declarations: [CargarFotoARLComponent],
    imports: [
      SharedModule,
      CommonModule,
      CargarFotoARLRouting
    ],
    entryComponents: []
  })

  export class CargarFotoARLModule{}